module.exports = __webpack_public_path__ + "1c954c8498aaba51d389d3c5ffef8429.png";